import { NaModel } from '../models/simple-types/na.model';
import { Ca2Model } from './../models/societe-linked/ca2.model';
import { UtilisateurModel } from 'src/app/shared/models/utilisateur/utilisateur.model';
import { NTHFlag } from '../constants/flag';
import { SocieteModel } from '../models/simple-types/societe.model';
import { Ca1Model } from '../models/societe-linked/ca1.model';
import { CompModel } from '../models/societe-linked/comp.model';
import { FournisseurModel } from '../models/societe-linked/fournisseur.model';
import { SiteModel } from '../models/societe-linked/site.model';
import { CategorieModel } from '../models/simple-types/categorie.model';
import { DefinitionNamesBC, DefinitionTypeBC } from '../typeBCDefinitions';

export class FilterBcDTO {

  public societe: SocieteModel = null;
  public idSociety: number = null;
  public bcSite: SiteModel = null; // codeLib Site BC
  public bcSiteLivr: SiteModel = null; // codeLib site de livraison BC
  public status: string[] = ['Brouillon', 'A Valider', 'Validation 1', 'Validation 2', 'Validation 3', 'Validation 4', 'Validé']; // statut
  public complement: CompModel = null;
  public libelle: string = "";
  public categorie: CategorieModel = null;
  public startNBc: string = ""; // N° BC du
  public endNBc: string = ""; // N° BC à
  public startNBcAmont: string = ""; // N° BC Amont du
  public endNBcAmont: string = ""; // N° BC Amont à
  public startDBc: Date = null; // Date du
  public endDBc: Date = null; // Date au
  public startDCreationBc: Date = null; // Date de création du
  public endDCreationBc: Date = null; // Date de création au
  public startDValiditeBcEnv: Date = null; // Date de validation enveloppe du
  public endDValiditeBcEnv: Date = null; // Date de validation enveloppe au
  public bcFourn: FournisseurModel = null; // codeLib fournisseur
  public refFourn: string = ""; // Reference fournisseur
  public libelleFourn: string = "";
  public startDLivBc: string = ""; // Date de livraison du
  public endDLivBc: string = ""; // Date de livraison au

  public fAnnule: NTHFlag[] = [0, 1, 2]; // annulé
  public fValide: NTHFlag[] = [0, 1, 2]; // validé
  public fLivre: NTHFlag[] = [0, 1, 2]; // livré
  public fFacture: NTHFlag[] = [0, 1, 2]; // facturé
  public bBloque: boolean[] = [true, false]; // bloqué
  public fProvis: NTHFlag[] = [0, 1, 2]; // provisionné
  public fDeprovis: NTHFlag[] = [0, 1, 2];  // déprovisionné
  public fHasBp: NTHFlag[] = [0, 1, 2]; // avec BP
  public fLitige: NTHFlag[] = [0, 1, 2]; // litige

  public idCreateur: number = null; // id créateur du BC
  public idValidateur: number = null; // id validateur du BC
  public bcCa1: Ca1Model = null; // CA1
  public bcCa2: Ca2Model = null; // CA2
  public startAe: string = ''; // N° AE du
  public endAe: string = ''; // N° ae au
  public startNa: NaModel = null; // codeLib Na du
  public endNa: NaModel = null; // codeLib Na au
  public typesBC: string[] = Object.values(DefinitionTypeBC); // statut //BC, enveloppe etc

  public type: string = null;
  public descending = false;
  public pageNumber = 0;
  public pageSize = 25;
  public order = 'dCreation';

  }
